export default __webpack_public_path__ + "static/media/model-home-icon.8c324a5f.svg";